module.exports = "li.parent ul.children li {\n  /*border-bottom: none !important;*/ }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/navigation/menu-item/menu-item.component.scss
// module id = ./src/app/shared/layout/navigation/menu-item/menu-item.component.scss
// module chunks = main